import OrderFragment from './OrderFragment';
export default `
  query ListAccountOrders(
    $filter: JSON
    $limit: Int
    $offset: Int
    $sortAttribute: String
    $sortDirection: String
  ) {
    listAccountOrders(
      filter: $filter
      limit: $limit
      offset: $offset
      sortAttribute: $sortAttribute
      sortDirection: $sortDirection
    ) {
      total
      size
      items {
        ...OrderFragment
      }
    }
  }
  ${OrderFragment}
`;
